module.exports = __webpack_public_path__ + "fonts/ComicNeueSansID.d594d4c1.woff2";